import { connect } from 'react-redux';

export default (component) => connect((state) => ({
  entityMgr: state.entityManagerReducer.record
}))(component);
